import {Injectable} from '@angular/core';
import {DeleteHeaderComponent} from '../../irb-common/components/grid/renderers/delete.header.component';
import {DeleteCellComponent} from '../../irb-common/components/grid/renderers/delete.cell.component';
import {Subject} from 'rxjs';
import {IrbSettingsService} from '@irb/irb-settings/irb-settings.service';
import {EditorModelService} from '@irb/irb-editors/editor-model/editor-model.service';
import {IrbEditorsService} from '@irb/irb-editors/irb-editors.service';
import {NumberTextBoxRendererComponent} from "@irb-common/components/grid/renderers/number-text-box.cell.component";
import { BlendedModelAllocationGroupcellComponent } from './blended-model-allocation-groupcell.component';
import { SecurityMasterAssetCategoryService } from '@irb/irb-models/security-master/security-master.asset-category.service';
import { DropdownSearchMultipleRendererComponent } from '@irb-common/components/grid/renderers/dropdown-search-multiple.cell.component';

@Injectable({
  providedIn: 'root'
})
export class BlendedModelsAllocationService {

  private allocationSecurities: Array<any> = [];
  dataChanged = new Subject<any>();
  globalSettings: any;
  globalSettingsSubject = new Subject<any>();
  totalPercentForBlended: any;

  constructor(public iss: IrbSettingsService,
              private editorModelService: EditorModelService,
              private ies: IrbEditorsService,
              private smac: SecurityMasterAssetCategoryService) {
  }

  getFrameworkComponents() {
    return {
      "DeleteHeaderComponent": DeleteHeaderComponent,
      "DeleteCellComponent": DeleteCellComponent,
      "NumberTextBoxRendererComponent":NumberTextBoxRendererComponent,
      "BlendedModelAllocationGroupcellComponent": BlendedModelAllocationGroupcellComponent,
      DropdownSearchMultipleRendererComponent: DropdownSearchMultipleRendererComponent
    };
  }


  getModelsColumnDefs(parent: any) {
    let cols: any = [{
      headerName: "Delete All",
      headerComponent: "DeleteHeaderComponent",
      headerComponentParams: {
        message: "Remove all security models?",
        note: "",
        proceed: parent.deleteAll.bind(parent),
        cancel: parent.cancelDelete.bind(parent)
      },
      cellRenderer: "DeleteCellComponent",
      cellRendererParams: {
        message: "Remove this security model?",
        note: "",
        proceed: parent.delete.bind(parent),
        cancel: parent.cancelDelete.bind(parent),
        hide: (params: any) => {
          return !params.data.securityId
        }
      },
      resizable: false,
      minWidth: 25,
      maxWidth: 25,
      width: 25,
      suppressColumnsToolPanel: true,
      // cellStyle: (params: any) => {
      //   if (params.data.securityId) {
      //     return {'background-color': '#fff'};
      //   }
      //   return null;
      // }
    }, {
      headerName: "Component Model",
      children: [
        {
          headerName: "Model Name",
          resizable: false,
          suppressMovable: true,
          field: "securityModelName",
          showRowGroup: true,
          cellRenderer: 'agGroupCellRenderer',
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            innerRenderer: 'BlendedModelAllocationGroupcellComponent',
            suppressEnterExpand: true,
          },
          minWidth: 120,
          flex: 1,
          tooltipField: "securityModelName",
          cellStyle: (params: any) => {
            if (!params.data.securityId) {
              return {'font-weight': 'bold'};
            }
            return '';//{'font-style': 'italic', 'background-color': '#fff'};
          },
          editable: false
        },
        {
          headerName: "Description",
          resizable: false,
          suppressMovable: true,
          field: "securityModelDescription",
          minWidth: 95,
          flex: 1,
          cellRenderer: "cellRendererFormatter",
          cellStyle: (params: any) => {
            if (!params.data.securityId) {
              return {'font-weight': 'bold'};
            }
            return '';//{'font-style': 'italic', 'background-color': '#fff'};
          },
          editable: false
        },
        {
          headerName: "CustCat",
          field: "customCategoryName",
          resizable: false,
          suppressMovable: true,
          colId: "CustCat",
          minWidth: 130,
          flex: 1,
          sortable: false,
          editable: false,
          // cellStyle: (params: any) => {
          //   if (!params.data.securityId) {
          //     return null;
          //   }
          //   return {'font-style': 'italic', 'background-color': '#fff'};
          // },
        }
      ]
    }];

        cols.push({
          headerName: 'Schwab Asset Classes',
          children: [
              {
                  headerName: "Level 1",
                  field: "acLevel1",
                  width: 250,
                  minWidth: 160,
                  flex: 1,
                  suppressFiltersToolPanel: true,
                  sortable: false,
                  cellClass: 'dropdownSearchMultipleCell',
                  cellRenderer: 'DropdownSearchMultipleRendererComponent',
                  cellRendererParams: (params: any) => {
                      return {
                          defaultValue: this.smac.getCellDisplayForAssetClasses(params.data.acLevel1),
                          noneDisplayText: params.data?.securitySymbol === '$CASH' ? 'Cash' : 'none',
                          cellStyle: "classes",
                          canEdit: false,
                          showNone: (params.data.securityId) ? true : false,
                          hiddenLabelPanelTitle: "Schwab Asset Classes - Level 1",
                          hiddenLabelDescription: "classes"
                      };
                  }
              },
              {
                  headerName: "Level 2",
                  field: "acLevel2",
                  width: 250,
                  minWidth: 160,
                  flex: 1,
                  suppressFiltersToolPanel: true,
                  sortable: false,
                  cellClass: 'dropdownSearchMultipleCell',
                  cellRenderer: 'DropdownSearchMultipleRendererComponent',
                  cellRendererParams: (params: any) => {
                      return {
                          defaultValue: this.smac.getCellDisplayForAssetClasses(params.data.acLevel2),
                          noneDisplayText: params.data?.securitySymbol === '$CASH' ? 'Cash' : 'none',
                          cellStyle: "classes",
                          canEdit: false,
                          showNone: (params.data.securityId) ? true : false,
                          hiddenLabelPanelTitle: "Schwab Asset Classes - Level 2",
                          hiddenLabelDescription: "classes"
                      };
                  },
                  hide: this.getDefaultHiddenState(parent, 'acLevel2', true)
              },
              {
                  headerName: "Level 3",
                  field: "acLevel3",
                  width: 250,
                  minWidth: 160,
                  flex: 1,
                  suppressFiltersToolPanel: true,
                  sortable: false,
                  cellClass: 'dropdownSearchMultipleCell',
                  cellRenderer: 'DropdownSearchMultipleRendererComponent',
                  cellRendererParams: (params: any) => {
                      return {
                          defaultValue: this.smac.getCellDisplayForAssetClasses(params.data.acLevel3),
                          noneDisplayText: params.data?.securitySymbol === '$CASH' ? 'Cash' : 'none',
                          cellStyle: "classes",
                          canEdit: false,
                          showNone: (params.data.securityId) ? true : false,
                          hiddenLabelPanelTitle: "Schwab Asset Classes - Level 3",
                          hiddenLabelDescription: "classes"
                      };
                  },
                  hide: this.getDefaultHiddenState(parent, 'acLevel3', true)
              },
              {
                  headerName: "Level 4",
                  field: "acLevel4",
                  width: 250,
                  minWidth: 160,
                  flex: 1,
                  suppressFiltersToolPanel: true,
                  sortable: false,
                  cellClass: 'dropdownSearchMultipleCell',
                  cellRenderer: 'DropdownSearchMultipleRendererComponent',
                  cellRendererParams: (params: any) => {
                      return {
                          defaultValue: this.smac.getCellDisplayForAssetClasses(params.data.acLevel4),
                          noneDisplayText: params.data?.securitySymbol === '$CASH' ? 'Cash' : 'none',
                          cellStyle: "classes",
                          canEdit: false,
                          showNone: (params.data.securityId) ? true : false,
                          hiddenLabelPanelTitle: "Schwab Asset Classes - Level 4",
                          hiddenLabelDescription: "classes"
                      };
                  },
                  hide: this.getDefaultHiddenState(parent, 'acLevel4', true)
              }
          ]});

      cols.push({
        headerName: "Allocation",
        children: [
          {
            headerName: "Target %",
            resizable: false,
            suppressMovable: true,
            field: "modelPercent",
            headerClass: 'editHeaderModelPercent',
            cellStyle: (params: any) => {
              if (!params.data.securityId) {
                return {'font-weight': 'bold'};
              }
              return '';//{'font-style': 'italic', 'background-color': '#fff'};
            },
            minWidth: 95,
            flex: 1,
            // valueFormatter: (params: any) => {
            //   return Number(params.value).toFixed(1);
            // },
            type: 'numericColumn',
            // editable: (params: any) => {
            //   return !params.data.securityId
            // },
            cellClass: 'numberTextBoxCell',
            cellRenderer: 'NumberTextBoxRendererComponent',
            cellRendererParams: (params: any) => {
              return {
                  // autofocus: true,
                  // autoSelect: true,
                min: 0,
                max: 100,
                places: 1,
                autoHeight: true,
                addZeroIfDotFirst: true,
                roundIfInvalid: true,
                disabled: params.data.securityId,
                onChange: (params: any, c: any) => {
                    if (params && params.data.modelPercent !== Number(c.value) && c.isValid) {
                    params.data.modelPercent = Number(c.value);
                    parent.onApplyTarget(params);
                  }
                },
              }
            }
          },
          {
            headerName: "Weighted Target %",
            field: "weightedTarget",
            resizable: false,
            suppressMovable: true,
            editable: false,
            minWidth: 95,
            flex: 1,
            type: 'numericColumn',
            headerClass: 'not-right-align',
            sortable: false,
            cellStyle: (params: any) => {
              if (!params.data.securityId) {
                return {'padding-right': '20px'};
              }
              // return {'font-style': 'italic', 'background-color': '#fff', 'padding-right': '20px'};
              return {'padding-right': '20px'};
            },
            valueGetter: (params: any) => {
              const val = params.data.securityId ? (params.data.mdlPer / 100 * params.data.targetPercentage).toFixed(1) : 'n/a';
              return val;
            }
          }
        ]
      });

      return cols;
  }

  combineAllSecurities(models: any) {
    let securities: Array<any> = [];
    models.forEach((model: any) => {
      model.securityModelDTO.securityModelAllocationList.forEach((sec: any)=> {
        sec.modelPercent = model.securityModelDTO.modelPercent;
        sec.securityModelName = model.securityModelDTO.securityModelName;
      });
      securities = securities.concat(model.securityModelDTO.securityModelAllocationList);
    });
    return securities;
  }

  getNoDuplicateSecuritiesCount(models: any) {
    const securities: any = this.combineAllSecurities(models);
    const securitiesMap: any = new Map();
    if (securities.length !== 0) {
      securities.forEach((sec: any) => {
        if (!securitiesMap.has(sec.securityId)) {
          securitiesMap.set(sec.securityId, true);
        }
      });
    }
    return securitiesMap.size;
  }

  changeData() {
    this.dataChanged.next(null);
  }

  setAllocationSecurities(allocSec: any) {
    this.allocationSecurities = allocSec;
  }
  getAllocationSecurities() {
    return this.allocationSecurities;
  }

  getGlobalSettings(data: any) {
    if (!this.globalSettings) {
      this.iss.getGlobalSettings().subscribe((globalSettings: any) => {
        this.globalSettings = globalSettings;
        this.globalSettingsSubject.next(null);
        this.editorModelService.setGlobalSettings(this.globalSettings);
        this.buildAllocationDataForGrid(data);
      });
    } else {
      this.editorModelService.setGlobalSettings(this.globalSettings);
      this.buildAllocationDataForGrid(data);
    }
  }

  private buildAllocationDataForGrid(data: any) {
    let listOfAllSecurities: any = [];
    this.editorModelService.clearAll();

    let gridData = [];
    const listOfModels: any = data.blendedSecurityModelAssociationsList.filter((x: any) => x.securityModelDTO.isUIdeleted !== true);
    if (listOfModels && listOfModels.length !== 0) {
      listOfAllSecurities = this.combineAllSecurities(listOfModels);
      listOfAllSecurities.sort((a: any, b: any) => (Number(a.targetPercentage) < Number(b.targetPercentage)) ? 1 : -1);
      gridData = this.getParentChildData(listOfAllSecurities);
      this.setCategoryMapping(gridData);
      this.setCategoryColors(gridData);
      this.checkSecurityUsageRuleAttributeConflict(gridData);
      this.setAllocationSecurities(gridData);
      this.changeData();
    } else {
      setTimeout(() => {
        this.allocationSecurities = [];
        this.changeData();
      },100);
    }

  }

  private getParentChildData(listOfAllSecurities: any) {
    let finalData: any = [],
        parentItem: any,
        childItem: any;

    listOfAllSecurities.forEach((security: any, idx: number) => {
      childItem = JSON.parse(JSON.stringify(security));
      childItem.parentChildId = 'parentChildId' + childItem.securityId + idx;
      childItem.weightedTarget = (childItem.modelPercent / 100 * childItem.targetPercentage).toFixed(2);
      childItem.securitySymbol = 'from model: ' + childItem.securityModelName;
      childItem.toleranceMinPercentageWT = this.calWeightedTarget(childItem.modelPercent, childItem.toleranceMinPercentage);
      childItem.toleranceMaxPercentageWT = childItem.toleranceMaxPercentage === 100 ? this.calWeightedTargetMax(childItem.weightedTarget) : this.calWeightedTarget(childItem.modelPercent, childItem.toleranceMaxPercentage);
      childItem.secEquivalentsDtoSet = childItem.secEquivalentsDtoSet || [];
      childItem.securityDescription = '';
      childItem.securityType = '';
      childItem.customCategoryName = '';
      childItem.acLevel1 = [];
      childItem.acLevel2 = [];
      childItem.acLevel3 = [];
      childItem.acLevel4 = [];
      if (this.checkIfSecurityPresent(finalData, security.securityId)) {
        finalData.forEach((item: any) => {
          if (item.securityId === security.securityId) {
            item.childItems.push(childItem);
            item.weightedTarget = (Number(item.weightedTarget) + Number(childItem.weightedTarget)).toFixed(2);
            item.toleranceMinPercentageWT += childItem.toleranceMinPercentageWT;
            item.toleranceMaxPercentageWT += childItem.toleranceMaxPercentageWT;
          }
        });
      } else {
        parentItem = JSON.parse(JSON.stringify(security));
        parentItem.childItems = [];
        parentItem.childItems.push(childItem);
        parentItem.weightedTarget = childItem.weightedTarget;
        parentItem.toleranceMinPercentageWT = childItem.toleranceMinPercentageWT;
        parentItem.toleranceMaxPercentageWT = childItem.toleranceMaxPercentageWT;
        finalData.push(parentItem);
      }
    });
    return finalData;
  }

  private calWeightedTarget(modelTarget: any, securityTarget: any) {
    if (modelTarget !== null && securityTarget !== null) {
      const a = Number(modelTarget) * Number(securityTarget);
      const b = a / 100;
      const rounded = Math.floor((b * 10) / 10);
      return b;
    } else {
      return 0;
    }
  }

  private calWeightedTargetMax(calWeightedTarget: any) {
    if (calWeightedTarget !== null && this.globalSettings.autoToleranceMaxPerc !== null) {
      const autoToleranceMaxPerc = this.globalSettings.autoToleranceMaxPerc / 100;
      const a = Number(calWeightedTarget) * Number(autoToleranceMaxPerc);
      let toleranceMaxPercentageWT = Number(calWeightedTarget) + a;
      toleranceMaxPercentageWT = toleranceMaxPercentageWT < 100 ? toleranceMaxPercentageWT : 100;
      return toleranceMaxPercentageWT;
    } else {
      return 0;
    }
  }

  private checkSecurityUsageRuleAttributeConflict(gridData: any) {
    let i: number = 0;
    let j: number = 0;
    let usageAttr: string, firstChildItem: any, usageAttrValue: any, usageAttrValueFirst: any;
    if (gridData && gridData.length !== 0) {
      gridData.forEach((item: any) => {
        if (item.childItems.length > 1) {
          firstChildItem = item.childItems[0];
          const usageRuleParams = ["useSecurityValue","buyMinimum","buyMinimumPercent","sellMinimumPercent","sellMinimum","tradeMinimumAlternative","taxabilityBias","rothLevel","inverseAccType","taxAltSymbolName","equivalenceQty","sellingTreatment","conditions","altSecurityId"];

          for (i = 0; i < usageRuleParams.length; i++) {
            usageAttr = usageRuleParams[i];
            usageAttrValueFirst = firstChildItem[usageAttr];

            for (j = 1; j < item.childItems.length; j++) {
              usageAttrValue = item.childItems[j][usageAttr];

              if ((usageAttrValueFirst !== usageAttrValue && usageAttr !== "equivalenceQty") || (usageAttr === "equivalenceQty" && this.checkConflictForEqvs(firstChildItem,item.childItems[j]))) {
                item.conflict = true;
                if (!item.attrList) {
                  item.attrList = [];
                }
                item.attrList.push(usageAttr);

              }
            }
          }
          item.conflictWsa = this.checkForTlhWsaConflict(item);
          if (item.conflict || item.conflictWsa) {
            this.updateConfictRecord(item);
          }
        }

      });
    }
  }

  private checkForTlhWsaConflict(item: any) {
    let conflictWsa = false;
    const firstTlh = item.childItems[0].isTlhEnabled;
    const firstWSA = item.childItems[0].tlhWashSaleAltSecuritiesDTO || [];
    let primaryWSA, secondaryWSA;
    if (firstWSA.length > 0) {
      primaryWSA = firstWSA[0].tlhWashReplaceSecurityId;
      if (firstWSA.length > 1) {
        secondaryWSA = firstWSA[1].tlhWashReplaceSecurityId;
      }
    }
    let tlhWashSaleAltSecuritiesDTO;
    for (let j = 1; j < item.childItems.length; j++) {
      tlhWashSaleAltSecuritiesDTO = item.childItems[j].tlhWashSaleAltSecuritiesDTO || [];
      if (firstTlh !== item.childItems[j].isTlhEnabled || firstWSA.length !== tlhWashSaleAltSecuritiesDTO.length) {
        conflictWsa = true;
        break;
      } else {
        if (tlhWashSaleAltSecuritiesDTO.length !== 0) {
          if (primaryWSA !== tlhWashSaleAltSecuritiesDTO[0].tlhWashReplaceSecurityId) {
            conflictWsa = true;
            break;
          } else {
            if (tlhWashSaleAltSecuritiesDTO.length > 1 && secondaryWSA !== tlhWashSaleAltSecuritiesDTO[1].tlhWashReplaceSecurityId) {
              conflictWsa = true;
              break;
            }
          }
        }
      }
    }
    return conflictWsa;
  }

  private updateConfictRecord(conflictRecord: any) {
    this.ies.getSecurityDetail(conflictRecord.securityId).subscribe((res: any) => {
      if (conflictRecord.conflict) {
        for (let i = 0; i < conflictRecord.attrList.length; i++) {

          let inverseSubSymb = null;
          let invrsAccountType = null;
          if (res.taxableAlternativeSymbol != null) {
            inverseSubSymb = res.taxableAlternativeSymbol;
            invrsAccountType = 'TAXABLE';

          } else if (res.qualifiedAlternativeSymbol != null) {
            inverseSubSymb = res.qualifiedAlternativeSymbol;
            invrsAccountType = 'QUALIFIED';
          }

          switch (conflictRecord.attrList[i]) {
            case "tradeMinimumAlternative":
              conflictRecord.tradeMinAltName = res.tradeMinAltName || res.tradeMinimumAlternativeSymb;
              break;
            case "taxAltSymbolName":
              conflictRecord.taxAltSymbolName = inverseSubSymb;
              conflictRecord.inverseAccType = invrsAccountType;
              break;
            case "inverseAccType":
              conflictRecord.taxAltSymbolName = inverseSubSymb;
              conflictRecord.inverseAccType = invrsAccountType;
              break;
            case "useSecurityValue":
              conflictRecord.useSecurityValue = true;
              break;
            case "buyMinimum":
              conflictRecord.buyMinimum = res.buyMinimum;
              break;
            case "sellMinimum":
              conflictRecord.sellMinimum = res.sellMinimum;
              break;
            case "buyMinimumPercent":
              conflictRecord.buyMinimumPercent = res.buyMinimumPercent;
              break;
            case "sellMinimumPercent":
              conflictRecord.sellMinimumPercent = res.sellMinimumPercent;
              break;
            case "taxabilityBias":
              conflictRecord.taxabilityBias = res.taxabilityBias;
              break;
            case "rothLevel":
              conflictRecord.rothLevel = res.rothLevel;
              break;
            case "equivalenceQty":
              conflictRecord.equivalenceQty = res.equivalenceQty;
              conflictRecord.altIfHeldSymbol = res.altIfHeldSymbol;
              conflictRecord.secEquivalentsDtoSet = res.secEquivalentsDtoSet;
              break;
            case "sellingTreatment":
            case "conditions":
            case "altSecurityId":
              conflictRecord.sellingTreatment = res.sellingTreatment;
              conflictRecord.conditions = res.conditions;
              conflictRecord.altSecurityId = res.altSecurityId;
              conflictRecord.altSecuritySymbol = res.altSecuritySymbol;
              conflictRecord.altSecuritydesc = res.altSecuritydesc;
              break;
          }
        }
      }
      if (conflictRecord.conflictWsa) {
        conflictRecord.isTlhEnabled = res.isTlhEnabled;
        conflictRecord.tlhWashSaleSymbol = res.tlhWashSaleSymbol;
        conflictRecord.tlhWashSaleAltSecuritiesDTO = res.tlhWashSaleAltSecuritiesDTO;
      }

      this.changeData();
    });
  }

  private checkConflictForEqvs(firstItem: any, secondItem: any) {
    let firstItemEqvsArr: any = [], secondItemEqvsArr: any = [];
    if (firstItem.secEquivalentsDtoSet.length > 0 && firstItem.secEquivalentsDtoSet[0] !== null) {
      firstItem.secEquivalentsDtoSet.forEach((entry: any) => {
        firstItemEqvsArr.push(entry.eqSecuritySymbol);
      });
    }
    if (secondItem.secEquivalentsDtoSet.length > 0 && secondItem.secEquivalentsDtoSet[0] !== null) {
      secondItem.secEquivalentsDtoSet.forEach((entry: any) => {
        secondItemEqvsArr.push(entry.eqSecuritySymbol);
      });
    }
    if (JSON.stringify(firstItemEqvsArr.sort()) === JSON.stringify(secondItemEqvsArr.sort())) {
      return false;
    } else
      return true;
  }

  private checkIfSecurityPresent(finalData: any, securityId: number) {
    const isPresent = finalData.filter((s: any) => s.securityId === securityId);
    return isPresent.length !== 0;
  }

  private setCategoryMapping(gridData: any) {
    this.editorModelService.createCustCatMap(gridData, 2, 'weightedTarget');
    this.editorModelService.changedData();
  }

  private setCategoryColors(gridData: any) {
    gridData.forEach((sec: any) => {
      sec.categoryColor = this.editorModelService.getColorByCategory(sec.customCategoryName);
    });
  }

  getGlobalSettingValues() {
    return this.globalSettings;
  }

  setTotalPercentForBlended(totalPercentForBlended: any) {
    this.totalPercentForBlended = totalPercentForBlended;
  }
  getTotalPercentForBlended() {
    return this.totalPercentForBlended;
  }

  getDefaultHiddenState(parent: any, fieldName: string, defaultState: boolean) {
      let s: any = JSON.parse(window.localStorage.getItem(parent.componentName) || "{}");

      if(s.COL_STATE) {
          let c: any  = JSON.parse(s.COL_STATE);

          if(c) {
              let d = c.find((x: any) => x.colId == fieldName);
              return d?.hide;
          }
      }

      return defaultState;
  }
}

